<div class='cart-widget'>
  <span class="fa fa-shopping-cart" aria-hidden="true"></span> ${{total|number:'1.2-2'}}
  <input type="button" class="btn btn-primary" value="View Cart" [routerLink]="['/admin', 'shop', 'checkout']" />
</div>


// WEBPACK FOOTER //
// ./src/app/admin/cart-widget/cart-widget.component.html